import { DefaultCard } from '../../../../../DefaultCard';
import { Link, mergeStyles, FontWeights } from '@fluentui/react';
import { useTranslation, Trans } from 'react-i18next';
import { Vulnerability } from 'types';

export const ExploitabilityAssessment = ({
  exploited,
  latestSoftwareRelease,
  publiclyDisclosed,
  enableShimmer,
}: IExploitabilityAssessmentProps) => {
  const [t] = useTranslation(['vulnerability', 'search']);

  if (!(publiclyDisclosed || exploited || latestSoftwareRelease)) {
    return null;
  }

  return (
    <DefaultCard
      header={t('exploitability.Exploitability', 'Exploitability')}
      id='exploitability'
      loading={enableShimmer}
    >
      <p>
        <Trans
          t={t}
          i18nKey='vulnerability:exploitability.subtitle'
          defaultValue='The following table provides an <0>exploitability assessment</0> for this vulnerability at the time of original publication.'
          components={[
            <Link
              key='linkKey'
              href='https://www.microsoft.com/msrc/exploitability-index'
              target='_blank'
              rel='noopener noreferrer'
            />,
          ]}
        />
      </p>
      <dl
        className={mergeStyles({
          dt: {
            fontWeight: FontWeights.semibold,
          },
        })}
      >
        <dt>{t('exploitability.PubliclyDisclosed', 'Publicly disclosed')}</dt>
        <dd>{publiclyDisclosed}</dd>
        <dt>{t('exploitability.Exploited', 'Exploited')}</dt>
        <dd>{exploited}</dd>
        <dt>
          {t(
            'exploitability.LatestSoftwareRelease',
            'Exploitability assessment'
          )}
        </dt>
        <dd>{latestSoftwareRelease}</dd>
      </dl>
    </DefaultCard>
  );
};

export interface IExploitabilityAssessmentProps
  extends Pick<
    Vulnerability,
    'publiclyDisclosed' | 'exploited' | 'latestSoftwareRelease'
  > {
  /**
   * If true, will show shimmer effect while loading data.
   */
  enableShimmer: boolean;
}
